import {dataTestId} from '@hconnect/uikit'
import {ModeCommentOutlined} from '@mui/icons-material'
import {Box, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {usePlanningComments} from '../../../../../shared/hooks/api/comments'
import {usePlanningChartStartEnd} from '../../PlanningChartStartEndProvider'

interface CommentSidebarButtonProps {
  toggleCommentSidebar: () => void
}

export const _CommentSidebarButton: React.FC<CommentSidebarButtonProps> = ({
  toggleCommentSidebar
}) => {
  const {t} = useTranslation()
  const {startOfPlan, endOfPlan, startOfChart, endOfChart} = usePlanningChartStartEnd()
  const {comments} = usePlanningComments({
    planTimeframe: [startOfPlan, endOfPlan],
    scheduleItemRange: [startOfChart, endOfChart]
  })

  return (
    <Box>
      <Button
        variant="text"
        sx={{color: 'primary.light'}}
        startIcon={<ModeCommentOutlined />}
        {...dataTestId('comments_sidebar_button')}
        onClick={toggleCommentSidebar}
      >
        {comments ? t('planning.numberOfComments', {count: comments.length}) : t('common.comments')}
      </Button>
    </Box>
  )
}

export const CommentSidebarButton = React.memo(_CommentSidebarButton)
